/**
 * @fileoverview: 隐私条款
 * @author: ShangJin
 * @date: 2019/4/2
 */
import React, {Component} from 'react';
import {render} from 'react-dom';

import '../../css/reset.css';
// import '../../css/term.less';
import './index.less';

import Title from 'c-title';
import lang from '../lang';

class TermRegister extends Component {
    componentWillMount() {
        Title.set(lang.template('隐私条款-网页标题'));
    }

    render() {
        const contentHtml = {
            __html: lang.template('隐私条款内容')
        };

        return (
            <div>
                <div className="terms-content" dangerouslySetInnerHTML={ contentHtml }></div>
            </div>
        );
    }
}

render(<TermRegister />, $('.wrap')[0]);



// WEBPACK FOOTER //
// ./js/privacy/index.js